import * as React from "react";
import type { SVGProps } from "react";
const SvgWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.36 11.782a1 1 0 1 0 1.28 1.536zm7.68-1.78v-1zm6.4 3.316a1 1 0 1 0 1.28-1.536zM.759 8.25a1 1 0 1 0 1.322 1.5zm21.16 1.5a1 1 0 0 0 1.322-1.5zM7.95 15.295a1 1 0 1 0 1.158 1.63zm6.95 1.63a1 1 0 0 0 1.158-1.63zM12 19a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zm-6.37-7.682a10 10 0 0 1 6.4-2.316v-2a12 12 0 0 0-7.68 2.78zm6.4-2.316a10 10 0 0 1 6.4 2.316l1.28-1.536a12 12 0 0 0-7.68-2.78zM2.081 9.75A15 15 0 0 1 12 6.003v-2A17 17 0 0 0 .759 8.25zM12 6.003a15 15 0 0 1 9.919 3.747l1.322-1.5A17 17 0 0 0 12 4.003zM9.11 16.925a5 5 0 0 1 2.895-.924v-2a7 7 0 0 0-4.054 1.294zm2.895-.924a5 5 0 0 1 2.896.924l1.158-1.63A7 7 0 0 0 12.005 14zM12 21h.01v-2H12z"
    />
  </svg>
);
export default SvgWifi;
